import { Component, ViewChild } from '@angular/core';
import { SharedModule } from 'src/app/core/shared/shared.module';
import {
  CommonTableComponent,
  QueryParamsModel,
  TableColumn
} from 'src/app/layouts/components/common-table/common-table.component';
import { CompletedFilesService } from './completed-files.service';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import { UserAuthenticationService } from 'src/app/core/navigation/user-authentication.service';
import { firstValueFrom } from 'rxjs';
import { ListConfigurationService } from 'src/app/pages/list-configuration/list-configuration.service';

@Component({
  selector: 'vex-completed-files',
  templateUrl: './completed-files-list.component.html',
  styleUrls: ['./completed-files-list.component.scss'],
  standalone: true,
  imports: [CommonTableComponent]
})
export class CompletedFilesComponent {
  @ViewChild('cnTable', { static: true })
  commonTableRef!: CommonTableComponent;
  public actions: Array<any> = [];
  public burgerActions: Array<any> = [];
  public columns: TableColumn<any>[] = [
    { label: 'ID', property: 'id', type: 'text', visible: false },
    {
      label: 'Name',
      property: 'form',
      type: 'text',
      visible: true
    },
    {
      label: 'Date',
      property: 'createdAt',
      type: 'text',
      visible: true
    }
  ];
  filter: any = {};
  userInfo: any;
  searchBy: [] = [];
  constructor(
    private completedFilesService: CompletedFilesService,
    private appSettingsService: AppSettingsService,
    public userCheck: UserAuthenticationService,
    private listConfigurationService: ListConfigurationService
  ) {}
  ngOnInit() {
    this.actions = [
      {
        key: 'viewFile',
        property: 'file'
      },
      { key: 'download', property: 'file' }
    ];
    this.userInfo = this.appSettingsService.userData().userDetails;
    setTimeout(async () => {
      await this.getListViewColumns('attachment');
    }, 0);
  }
  async init() {
    try {
      this.inItFilterOptions();
    } catch {}
  }
  inItFilterOptions() {
    this.filter.where = {
      userId: this.userCheck.checkUser() ? null : this.userInfo?.id
    };
  }
  public async onLoadItemsEvent(queryParams: QueryParamsModel) {
    await this.init();
    if (Object.keys(this.filter).length) {
      queryParams.filter = JSON.stringify(this.filter);
    }
    this.completedFilesService
      .getCompletedFiles(queryParams)
      .subscribe((resp) => {
        this.commonTableRef.loadItems(resp);
      });
  }

  onActionClickEmit(ev: any) {
    let key = ev.action.key;
    switch (key) {
      case 'edit':
        // this.editTeam(ev.data.id);
        break;
      case 'delete':
        // this.deleteStaff(ev.data.id);
        break;

      default:
        break;
    }
  }

  async getListViewColumns(page: string) {
    try {
      const resp = await firstValueFrom(
        this.listConfigurationService.getlistViewColumns(page)
      );
      let respItems: any = resp.items[0].columns;
      let string = this.userCheck.checkUser() ? 'isCQA' : 'isCompany';
      const filteredColumn = respItems.tableColumn.filter(
        (i: any) => i[string]
      );

      const newColumn = this.userCheck.checkUser()
        ? respItems.tableColumn.map((item: any) => ({
            label: item.label,
            property: item.property,
            type: 'text',
            visible: item.isCQA ? true : false,
            tableName: item.tableName
          }))
        : filteredColumn.map((item: any) => ({
            label: item.label,
            property: item.property,
            type: 'text',
            visible: item.isCompany,
            tableName: item.tableName
          }));

      this.columns = newColumn.length > 0 ? newColumn : this.columns;

      this.columns.push({
        label: 'Actions',
        property: 'actions',
        type: 'button',
        visible: true
      });
      this.searchBy = respItems.searchBy.map((item: any) => item.isActive);
    } catch (err) {
      this.appSettingsService.handleError(err);
    }
  }
}
